import { motion } from "framer-motion";
import type { NihaoBridgeContent } from "../content/types";

interface WhyRedBookSectionProps {
  content: NihaoBridgeContent["whyRedBook"];
}

export default function WhyRedBookSection({ content }: WhyRedBookSectionProps) {
  return (
    <section className="w-full py-20 px-[5%] bg-white" id="why-redbook">
      <div className="max-w-5xl mx-auto text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-3xl lg:text-4xl font-bold mb-8 text-slate-900"
        >
          {content.title}
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          viewport={{ once: true }}
          className="text-lg text-slate-600 leading-relaxed space-y-6"
        >
          <p
            dangerouslySetInnerHTML={{
              __html: content.paragraph1.replace(
                /RedBook \(Xiaohongshu \/ 小红书\)/,
                '<strong class="text-slate-800">RedBook (Xiaohongshu / 小红书)</strong>'
              ),
            }}
          />
          <p>{content.paragraph2}</p>
        </motion.div>
      </div>
    </section>
  );
}
